export const LEAVE_PLAN_FILTERS = {
  ISSUER: 'issuer',
  MANAGER: 'manager',
  LEAD: 'lead',
  MEMBER: 'member',
  APPRAISER: 'appraiser',
  COAPPRAISER: 'coappraiser',
};

export const TODAYS_LEAVES_LABEL = "Today's Leaves";

export const LEAVE_STATUS_COLORS = {
  REQUESTED: '#ab22ff',
  DEFAULT: '#B3B3B3',
};
